module.exports = __webpack_public_path__ + "media/assets/images/logos/moneytree-a943bcef1513be09b96423d44f9c961d.png";